import { render, staticRenderFns } from "./PermissionsDivisionsForm.vue?vue&type=template&id=5ff5b830&scoped=true&"
import script from "./PermissionsDivisionsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsDivisionsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff5b830",
  null
  
)

export default component.exports